enum CourseStatusEnum{
    Draft = 1,
    PendingApproval = 2,
    Approved = 3,
    Published = 4,
    Archived = 5   
}

export default CourseStatusEnum